<template>
  <v-sheet>
    <div class="accent-block mt-4 mb-4" v-if="afficheAideCreation">
      <p>
        Vous pouvez accompagner votre dépôt d'annexes, pour ce faire merci de les ajouter
        ci-dessous.
      </p>
      <p>
        A défaut si vous souhaitez envoyer directement certaines annexes, par voie
        postale, au tribunal compétent merci de le préciser dans la partie observation de
        ce formulaire.
      </p>
      <template v-if="creation">
        <p>
          Nous vous rappelons qu'afin que votre demande soit complète il convient de
          joindre au présent formulaire un fichier pour chacun des documents suivants :
        </p>
        <ul style="list-style: none">
          <li>
            <a-plain-check :value="declarationInscription" /> une déclaration en vue de
            l'inscription
          </li>
          <li>
            <a-plain-check :value="pvAG" /> une copie du procès verbal d'AG constitutive
          </li>
          <li><a-plain-check :value="statuts" /> une copie des statuts</li>
        </ul>
      </template>
      <template v-if="modification || dissolution">
        <p>
          Nous vous rappelons qu'afin que votre demande soit complète il convient de
          joindre au présent formulaire :
        </p>
        <ul style="list-style: none">
          <li><a-plain-check :value="auMoins1" /> au moins un document</li>
        </ul>
      </template>
      <template v-if="radiation">
        <p>
          Nous vous rappelons qu'afin que votre demande soit complète il convient de
          joindre au présent formulaire si cela n'a pas déjà été effectué :
        </p>
        <ul style="list-style: none">
          <li>
            <a-plain-check :value="extraitPublicationDissolutionPlusUnAn" /> l'extrait de
            publication au JAL de la dissolution de l'association daté de plus d'un an
          </li>
        </ul>
      </template>
    </div>
    <v-row class="mb-4">
      <v-col cols="12">
        <a-plain-text-component :rules="[serverRule('documents'), taillesMaxRules]">
          <span class="am-t2 bold"> Annexes</span>
        </a-plain-text-component>
      </v-col>
      <v-col cols="12" v-if="afficheAideCreation">
        <div class="d-flex justify-center">
          <v-btn data-testid="ajouter-annexe" @click="ajouter"> Ajouter une annexe </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="4" v-for="(a, i) in annexes" :key="`${i}`">
        <a-document-card
          :value="a"
          :index="i"
          @supprimer="supprimer(i)"
          @telecharge="telecharge(a)"
        />
      </v-col>
    </v-row>
    <a-document-dialog
      ref="dialog"
      :codePostal="codePostal"
      :typesDocuments="typesDocumentsDialog"
    />
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";
import { requeteService } from "@/services";
import { mapGetters } from "vuex";
import bytes from "@/filters/bytes";

function mapTo(src, dest) {
  src = src || {};
  dest.annexes = src.annexes || [];
}

function plusUnAns(dateDissolutionJAL) {
  const a = new Date(dateDissolutionJAL);
  const b = new Date();

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY) >= 365;
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo, false), makeRules(), ValueDataRules],
  props: {
    modification: {
      type: Boolean,
      default: false,
    },
    dissolution: {
      type: Boolean,
      default: false,
    },
    radiation: {
      type: Boolean,
      default: false,
    },
    codePostal: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      url: null,
    };
  },
  mounted() {
    this.$nextTick(() => this.emitDisabled());
  },
  beforeDestroy() {
    if (this.url) {
      window.URL.revokeObjectURL(this.url);
      this.url = null;
    }
  },
  methods: {
    ajouter() {
      let tmpDoc = null;
      this.$refs.dialog.nouveau(
        doc => {
          tmpDoc = doc;
          const { fichier, nom, journal, type, sousType, date } = doc;
          return requeteService.validationDocument(
            this.mode,
            { nom, journal, type, sousType, date },
            fichier
          );
        },
        () => {
          // on utilise le fichier temporaire pour le TS car les fichiers n'existent pas coté serveur
          this.annexes.push({ ...tmpDoc, actionsPossible: true });
          this.changed();
        }
      );
    },
    supprimer(index) {
      this.annexes.splice(index, 1);
      this.$emit("clearValidation", index);
      this.changed();
    },
    telecharge(a) {
      this.url = URL.createObjectURL(a.fichier);
      window.open(this.url, "_blank");
    },
    emitDisabled() {
      this.$emit("disabled", this.suiteDisabled);
    },
  },
  watch: {
    suiteDisabled() {
      this.emitDisabled();
    },
    totalSuperieurTailleMax() {
      this.$emit("validate");
    },
  },
  computed: {
    mode() {
      if (this.modification) {
        return "modification";
      } else if (this.dissolution) {
        return "dissolution";
      } else if (this.radiation) {
        return "radiation";
      }
      return "creation";
    },
    typesDocumentsDialog() {
      return this.creation ? null : "pieces";
    },
    creation() {
      return !this.modification && !this.dissolution && !this.radiation;
    },
    ...mapGetters({
      tailleMax: "fichiers/tailleMax",
      documentsOrigine: "modificationAssociation/documents",
    }),
    taillesMaxRules() {
      if (this.totalSuperieurTailleMax) {
        return `La taille des fichiers dépasse la limite de ${bytes(this.tailleMax)}`;
      }
      return true;
    },
    tailleAnnexesTotale() {
      return this.annexes.map(a => a.taille).reduce((a, b) => a + b, 0);
    },
    totalSuperieurTailleMax() {
      return this.tailleAnnexesTotale > this.tailleMax;
    },
    auMoins1() {
      return this.annexes.length > 0;
    },
    datePublicationDissolutionAncien() {
      const dates = [...this.annexes, ...this.documentsOrigine]
        .filter(doc => doc.type === "EXTRAIT_PUB_JAL" && doc.sousType === "PUBDIS")
        .map(d => d.date)
        .sort((a, b) => (a || "0000-00-00").localeCompare(b));
      return dates.length ? dates[0] : null;
    },
    extraitPublicationDissolutionPlusUnAn() {
      return (
        this.datePublicationDissolutionAncien &&
        plusUnAns(this.datePublicationDissolutionAncien)
      );
    },
    typesDocuments() {
      return this.annexes.map(a => a.type);
    },
    declarationInscription() {
      return this.typesDocuments.includes("DECLARATION_INSCR");
    },
    statuts() {
      return this.typesDocuments.includes("STATUTS");
    },
    pvAG() {
      return this.typesDocuments.includes("PV_AG");
    },
    suiteDisabled() {
      if (this.totalSuperieurTailleMax) {
        return true;
      }

      if (this.creation)
        return !this.declarationInscription || !this.statuts || !this.pvAG;

      if (this.modification || this.dissolution) return !this.auMoins1;

      return false;
    },
  },
};
</script>
